import { Injectable, Injector, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { VersionHelper } from '@app/app/shared/helpers/version.helper';
import { TranslocoService } from '@ngneat/transloco';
import { take } from 'rxjs';
import { PageTitleService } from './page-title.service';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private injector = inject(Injector);
  private transloco = inject(TranslocoService);
  private activeRoutes: Route[] = [];

  override updateTitle(snapshot: RouterStateSnapshot): void {
    if (!VersionHelper.isV3Enabled()) {
      return;
    }

    const routes = primaryRoutes(snapshot.root);
    const sameRoutes = routes.length === this.activeRoutes.length && routes.every((route, index) => route === this.activeRoutes[index]);
    this.activeRoutes = routes;

    if (sameRoutes) {
      return;
    }

    const pageTitle = this.injector.get(PageTitleService);

    if (pageTitle.keepsPageTitle(routes)) {
      return;
    }

    const titleKey = this.buildTitle(snapshot);

    if (!titleKey) {
      pageTitle.setNavigationTitle(null);
      return;
    }

    const changeCount = pageTitle.changeCount;
    this.transloco
      .selectTranslate(titleKey)
      .pipe(take(1))
      .subscribe((title) => {
        if (pageTitle.changeCount === changeCount) {
          pageTitle.setNavigationTitle(title);
        }
      });
  }
}

function primaryRoutes(root: ActivatedRouteSnapshot): Route[] {
  const routes: Route[] = [];

  for (let route: ActivatedRouteSnapshot | null = root; route; route = route.firstChild) {
    if (route.routeConfig) {
      routes.push(route.routeConfig);
    }
  }

  return routes;
}
